module.exports = __webpack_public_path__ + "static/media/arrow-down.58914d20.svg";